import type { Container } from 'pixi.js';
import { HTMLText } from 'pixi.js';
import { onLayoutPopulated } from '../populate';

export type TextWithColorTags = HTMLText & { data?: { colorTags?: Record<string, string> } };

export function processColorTags(textObj: TextWithColorTags, colorTags?: Record<string, string>): void {
  let newText = textObj.text;

  Object.entries(colorTags ?? textObj.data?.colorTags ?? {}).forEach(([tag, color]) => {
    const lastIndex = -1;
    let closing = false;

    while (newText.includes(tag, lastIndex + 1)) {
      const index = newText.indexOf(tag, lastIndex + 1);
      if (index === -1) return;

      const pre = newText.substring(0, index);
      const spanTag = closing ? '</span>' : `<span style='color: ${color}'>`;
      const post = newText.substring(index + 1);
      newText = `${pre}${spanTag}${post}`;
      closing = !closing;
    }
  });

  textObj.text = newText.replaceAll('\\n', '<br>');
}

export function layoutColorTagsSPL(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; colorTags_SPL?: TextWithColorTags[] }) => {
    if (!layout.colorTags_SPL) return;

    layout.colorTags_SPL.forEach((textObj) => {
      if (!(textObj instanceof HTMLText)) {
        console.warn('colorTags_SPL used on non HTMLText object');
        return;
      }

      processColorTags(textObj);
    });
  });
}
